import store from "../../store/index.js"
const view = {
  pm_course_play_view: function ({ currentTime, duration, userId, themeUuid, liveUuid, liveType, users, catalogId, coursewareId, isFirst, sid }) {
    var playTime = "";
    isFirst ? playTime = "0" : playTime = "30";
    var datas = {
      eventId: "pm_course_play_view",
      liveType: "02",
      //apptype改为用户类型了⌚️
      appType: store.state.userPlatfromType,
      channel: "02",
      userId: userId,
      eventType: "01",
      eventTime: new Date().getTime(),
    }
    datas.attstr = {
      sid: sid,
      themeUuid: themeUuid,
      liveUUID: liveUuid,
      liveType: liveType,
      courseHeat: users,
      catalogId: catalogId,
      coursewareId: coursewareId,
      playTime: playTime,
      videoTime: Math.floor(currentTime) * 1000,
      videoTotal: Math.floor(duration) * 1000,
    }
    var items = [];
    items.push(datas);
    var res = {
      items: items
    };
    return res;
  },
  pm_live_play_view: function ({ userId, sid, liveUuid, time, total }) {
    var datas = {
      eventId: "pm_live_play_view",
      liveType: "02",
      //apptype改为用户类型了⌚️
      appType: store.state.userPlatfromType,
      channel: "02",
      userId: userId,
      eventType: "01"
    }
    datas.attstr = {
      sid: sid,
      liveUUID: liveUuid,
      liveType: "0",
      playTime: time,
      videoTotal: total,
      liveStatus: "1"
    }
    var items = [];
    items.push(datas);
    var res = {
      items: items
    };
    return res;
  },
  extend: function (parent) {
    var child = {};
    for (var i in parent) {
      child[i] = parent[i];
    }
    child.uber = parent;
    return child;
  },
  reportOfBuriedSite: function (param) {
    let { eventId, eventType, userId, attstr } = param;
    let datas = {
      eventId: eventId,
      liveType: "02",
      appType: "03",
      channel: "02",
      userId: userId,
      eventType: eventType
    }
    datas.attstr = attstr;
    var items = [];
    items.push(datas);
    var res = {
      items: items
    };
    return res;
  },
  generateUUID: function () {
    var d = new Date().getTime();
    var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      var r = (d + Math.random() * 16) % 16 | 0;
      d = Math.floor(d / 16);
      return (c == 'x' ? r : (r & 0x3 | 0x8)).toString(16);
    });
    return uuid;
  }

}
export default view;


// WEBPACK FOOTER //
// ./src/cmtapp/components/util/pm_course_play_view.js